// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class Margins {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Margins {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  top(): number {
    return this.bb!.readFloat32(this.bb_pos)
  }

  bottom(): number {
    return this.bb!.readFloat32(this.bb_pos + 4)
  }

  left(): number {
    return this.bb!.readFloat32(this.bb_pos + 8)
  }

  right(): number {
    return this.bb!.readFloat32(this.bb_pos + 12)
  }

  static sizeOf(): number {
    return 16
  }

  static createMargins(
    builder: flatbuffers.Builder,
    top: number,
    bottom: number,
    left: number,
    right: number
  ): flatbuffers.Offset {
    builder.prep(4, 16)
    builder.writeFloat32(right)
    builder.writeFloat32(left)
    builder.writeFloat32(bottom)
    builder.writeFloat32(top)
    return builder.offset()
  }
}
